export const PRODUCTION_HELP_API = 'https://help-agent-api-vm77772tsa-uc.a.run.app';
export const CANDIDATE_APP_HOST = 'candidate---help-agent-app-vm77772tsa-uc.a.run.app';
export const CANDIDATE_HELP_API = 'https://candidate---help-agent-api-vm77772tsa-uc.a.run.app';

const PRODUCTION_APP_HOST = 'help-agent-app-vm77772tsa-uc.a.run.app';
const PRODUCTION_CUSTOM_HOST = 'help.samsurveyor.com';

/**
 * Resolve the Help API solely from the browser hostname. Query parameters,
 * storage, globals, and other runtime mutation points are intentionally absent.
 */
export function resolveHelpApiBase(hostname, configuredBase = '') {
    let expected;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        expected = 'http://localhost:8091';
    } else if (hostname === CANDIDATE_APP_HOST) {
        expected = CANDIDATE_HELP_API;
    } else if (hostname === PRODUCTION_CUSTOM_HOST || hostname === PRODUCTION_APP_HOST) {
        expected = PRODUCTION_HELP_API;
    } else {
        // An unknown host must never synthesize or select a candidate endpoint.
        expected = PRODUCTION_HELP_API;
    }

    if (configuredBase && configuredBase !== expected) {
        throw new Error('Help API override does not match the trusted hostname route');
    }
    return expected;
}
